import { call, put } from "redux-saga/effects";
import { API_URLS } from "../../../config";
import { CallApi } from "./api/callApi";
import { addedIp, removedIp, storeCalendarEvent, storeIp, updatedIp } from "../../redux/slices/organizationSlice";

export function* addIpSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.IP.ROUTE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(addedIp(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* getAllIpSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.IP.ROUTE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeIp(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}




export function* getCurrentIpSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.IP.CURRENT_IP, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* toggleIpSaga(action) {
    try {
        const data = action.payload;
        const { id } = data.data
        const resp = yield call(CallApi.PUT, `${API_URLS.ORGANIZATION.IP.ROUTE}/${id}`, null, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(updatedIp(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* deleteIpSaga(action) {
    try {

        const data = action.payload;
        const { id } = data.data
        const resp = yield call(CallApi.DELETE, `${API_URLS.ORGANIZATION.IP.ROUTE}/${id}`, null, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(removedIp(id))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* addShiftSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.SHIFT.ADD_SHIFT, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* getAllShiftSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.SHIFT.VIEW_SHIFT, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* udpateShiftSaga(action) {
    try {
        const data = action.payload;
        const { id, ...dt } = data?.data;
        const resp = yield call(CallApi.PATCH, API_URLS.ORGANIZATION.SHIFT.UPDATE_SHIFT.replace(":id", id), dt, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}





export function* createCalendarSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.ORGANIZATION.CALENDAR.ROUTE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* getAllCalendarSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.CALENDAR.ROUTE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeCalendarEvent(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* getAllCalendarRangeSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.ORGANIZATION.CALENDAR.RANGE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {

            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* updateCalenderSaga(action) {
    try {
        const data = action.payload;
        const { id, ...d } = data.data
        const resp = yield call(CallApi.PATCH, `${API_URLS.ORGANIZATION.CALENDAR.ROUTE}/${id}`, d, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(storeCalendarEvent(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* deleteCalenderSaga(action) {
    try {
        const data = action.payload;
        const { id, ...d } = data.data
        const resp = yield call(CallApi.DELETE, `${API_URLS.ORGANIZATION.CALENDAR.ROUTE}/${id}`, d, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(storeCalendarEvent(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}